import React, { createContext, useState } from "react";
import { Divider, Button, Modal, Carousel } from "antd";
import moment from "moment";
import { MEAL_TYPE_VN, BED_TYPE_VN } from "../../helpers/const";
import _ from "lodash";
const ReachableContext = createContext(null);

const RoomItem = ({ data, setRoomRateSelected, loading, indexRoom }) => {
  const [modal, contextHolder] = Modal.useModal();
  const [previewOpen, setPreviewOpen] = useState(false);

  const photos =
    Array.isArray(data?.photos) && data.photos.length > 0
      ? data.photos
      : Array.isArray(data?.images) && data.images.length > 0
        ? data.images
        : data?.thumbnail
          ? [data.thumbnail]
          : [];
  const cover =
    photos[0]?.origin ||
    photos[0]?.large ||
    data?.thumbnail?.origin ||
    data?.thumbnail?.large;

  const openModalCancle = (rate) => {
    const instance = modal.info({
      title: "",
      maskClosable: false,
      closable: false,
      icon: null,
      footer: [
        <div className="w-full text-center">
          <Button
            key="ok"
            type="primary"
            onClick={() => instance.destroy()}
            className="bg-primary text-white"
          >
            Đóng
          </Button>
        </div>,
      ],
      content: (
        <>
          <ReachableContext.Consumer>
            {() => (
              <>
                {rate?.cancellationpolicies?.length === 1 ? (
                  <>
                    <div className="mt-1 pl-3">
                      Huỷ trước{" "}
                      <span className="font-semibold">
                        {moment(rate.cancellationpolicies[0].deadline).format(
                          "HH:mm DD/MM/YYYY",
                        )}{" "}
                      </span>
                      : Miễn phí
                    </div>
                    <div className="pl-3">
                      Huỷ sau{" "}
                      <span className="font-semibold">
                        {" "}
                        {moment(rate.cancellationpolicies[0]?.deadline).format(
                          "HH:mm DD/MM/YYYY",
                        )}{" "}
                        :{" "}
                      </span>
                      <span className="text-red-600 font-semibold">
                        {" "}
                        {rate.cancellationpolicies[0]?.penalty?.toLocaleString(
                          "vi-VN",
                        )}{" "}
                        đ
                      </span>
                    </div>
                  </>
                ) : (
                  <div>
                    {rate?.cancellationpolicies?.map((can, index) => (
                      <div>
                        {index === 0 && (
                          <div>
                            Huỷ trước{" "}
                            <span className="font-semibold">
                              {moment(can.deadline).format("HH:mm DD/MM/YYYY")}
                            </span>{" "}
                            : Miễn phí
                          </div>
                        )}
                        {index > 0 &&
                          index < rate?.cancellationpolicies?.length - 1 && (
                            <div>
                              Huỷ từ{" "}
                              <span className="font-semibold">
                                {moment(
                                  rate?.cancellationpolicies[index - 1]
                                    ?.deadline,
                                ).format("HH:mm DD/MM/YYYY")}{" "}
                              </span>
                              đến{" "}
                              <span className="font-semibold">
                                {" "}
                                {moment(can.deadline).format(
                                  "HH:mm DD/MM/YYYY",
                                )}{" "}
                              </span>
                              :
                              <span className="text-red-500">
                                {" "}
                                {rate.cancellationpolicies[
                                  index - 1
                                ]?.penalty.toLocaleString("vi-VN")}
                                đ
                              </span>
                            </div>
                          )}
                        {index === rate?.cancellationpolicies?.length - 1 && (
                          <div>
                            Huỷ sau{" "}
                            <span className="font-semibold">
                              {" "}
                              {moment(can.deadline).format("HH:mm DD/MM/YYYY")}
                            </span>{" "}
                            :
                            <span className="text-red-500">
                              {can?.penalty.toLocaleString("vi-VN")} đ
                            </span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </ReachableContext.Consumer>
          <br />
        </>
      ),
    });
  };

  return (
    <>
      <div className="p-4 bg-white rounded-bl-[12px] rounded-br-[12px] flex flex-col">
        <div className="mb-3">
          <span className="text-primary text-[16px] font-semibold">
            {" "}
            {indexRoom}. {data.roomtypename} - {data?.area?.squareMeter} m2
          </span>
        </div>
        {/* <div className="mb-3">
          <span className="font-semibold">Mã loại phòng</span>:{" "}
          {data.roomTypeCode}
        </div> */}
        {/* <div className="font-semibold mb-2">Các Lưa cụ thể: </div> */}

        <div
          className="relative w-full cursor-pointer"
          style={{ paddingTop: "56.25%" }}
          onClick={() => photos.length > 0 && setPreviewOpen(true)}
        >
          <img
            src={cover}
            alt=""
            className="rounded-tl-[12px] rounded-tr-[12px] absolute top-0 left-0 w-full h-full object-cover"
          />
        </div>
        {photos.length > 0 && (
          <div className="w-full text-right">
            <a
              href="#!"
              onClick={(e) => {
                e.preventDefault();
                setPreviewOpen(true);
              }}
              className="text-primary text-[13px] underline cursor-pointer"
            >
              Xem ảnh ({photos.length})
            </a>
          </div>
        )}
        {Array.isArray(data?.groupAmenities) &&
          data.groupAmenities.length > 0 && (
            <div className="w-full mt-2">
              <div className="font-semibold mb-2">Tiện ích phòng</div>
              <div className="flex flex-col gap-2">
                {data.groupAmenities.map((group) => (
                  <div key={group.id}>
                    <div className="text-[13px] font-semibold text-[#4A5568] mb-1">
                      {group.name}
                    </div>
                    <div className="flex flex-wrap gap-x-4 gap-y-1">
                      {group.amenities?.map((a) => (
                        <div
                          key={a.id}
                          className="flex items-center gap-1 text-[13px] text-[#4A5568]"
                        >
                          {a.icon && (
                            <img
                              src={a.icon}
                              alt=""
                              className="w-[16px] h-[16px] object-contain"
                            />
                          )}
                          <span>{a.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        {Array.isArray(data?.views) && data.views.length > 0 && (
          <div className="w-full mt-3">
            <div className="font-semibold mb-1">View phòng</div>
            <div className="text-[14px] text-[#4A5568]">
              {data.views.map((v) => v.name).join(", ")}
            </div>
          </div>
        )}
        <Divider
          variant="dashed"
          dashed
          className="my-2"
          style={{ borderColor: "var(--primary-color)" }}
        />

        {data.rates.map((rate, index) => (
          <div className="px-2 flex flex-col items-center gap-2">
            <div className="flex justify-between w-full">
              <span className="font-semibold">Lựa chọn {index + 1}</span>
              {/* <span className="text-[#00b6f3]">Thông tin phòng</span> */}
            </div>
            <div className="flex-1 w-full">
              <div className="text-[#4A5568] flex items-center gap-2 mb-2">
                <img src="/images/ic-money.svg" alt="" />
                <span>
                  {" "}
                  {rate?.cancellationpolicies?.length > 0
                    ? "Hoàn huỷ một phần"
                    : "Không hỗ trợ hoàn huỷ"}
                </span>
                {rate?.cancellationpolicies?.length > 0 && (
                  <img
                    src="/images/icon-noti.svg"
                    alt=""
                    onClick={() => openModalCancle(rate)}
                  />
                )}
              </div>

              <div className="text-[#4A5568] flex items-center gap-2 mb-2">
                <img src="/images/ic-meal.svg" alt="" />
                <span>
                  {" "}
                  {rate.mealType > 0
                    ? `Bao gồm ${_.toLower(MEAL_TYPE_VN[rate.mealType])}`
                    : "Không bao gồm bữa ăn"}
                </span>
              </div>

              {rate?.bedtype?.beds?.length > 0 && (
                <div className="text-[#4A5568] flex items-center gap-2 mb-2">
                  <img src="/images/ic-bed.svg" alt="" />
                  <span>
                    {" "}
                    {rate?.bedtype?.beds?.length === 1
                      ? `${rate?.bedtype?.beds[0]?.count} ${_.toLower(
                        BED_TYPE_VN[rate?.bedtype?.beds[0]?.code],
                      )}`
                      : `${rate.bedtype.beds
                        .map((bed, index) => {
                          let relation = "";
                          if (index < rate.bedtype.beds.length - 1) {
                            relation =
                              rate.bedtype.relation === "AND" ? "và" : "hoặc";
                          }
                          return (
                            bed.count +
                            " " +
                            _.toLower(BED_TYPE_VN[bed.code]) +
                            " " +
                            relation
                          );
                        })
                        .join(" ")}`}
                  </span>
                </div>
              )}

              <div className="text-[#4A5568] flex items-center gap-2 mb-2">
                <img
                  className="w-[18px] h-[18px]"
                  src="https://storage.googleapis.com/tripi-assets/images/hotels/amenities/doanhnhanh/phong-hop.png"
                  alt=""
                />
                <span>Đặt tối đa: {rate.bookinglimit} phòng</span>
              </div>

              <div className="text-[#ed8936] flex items-center gap-2 mb-2">
                <img src="/images/ic-confirm.svg" alt="" />
                <span>Xác nhận ngay</span>
              </div>

              <div className="text-[#ff3366] flex items-center gap-2 mb-2">
                <img src="/images/ic-vat.svg" alt="" />
                <span>
                  An tâm đặt phòng, Ipass hỗ trợ xuất hoá đơn nhanh chóng, tiết
                  kiệm thời gian cho bạn.
                </span>
              </div>
              {/* <div className="mt-2">
                Tổng tiền trước thuế :{" "}
                <span className="text-[16px] text-primary font-bold">
                  {rate?.rateBeforeTaxTotalNew?.toLocaleString("vi-VN")} đ
                </span>
              </div> */}

              {/* <span className="font-semibold">Loại giường: {BED_TYPE[rate.]}</span> */}
            </div>
            <div className="flex flex-col w-full">
              <div className="flex justify-between items-center w-full">
                <span className="text-[12px] italic">
                  Được cung cấp bởi đối tác của chúng tôi
                </span>
                <span className="text-[18px] text-primary font-bold">
                  {rate?.rateaftertaxtotal?.toLocaleString("vi-VN")} đ
                </span>
              </div>

              <Button
                color="default"
                onClick={() => {
                  setRoomRateSelected(rate, data);
                }}
                loading={loading}
                type="primary"
                className="text-white mt-2 w-[140px] ml-auto h-[36px]"
              >
                <span className="font-semibold">Đặt ngay</span>
              </Button>
            </div>
            <Divider
              variant="dashed"
              dashed
              className="my-2"
              style={{ borderColor: "var(--primary-color)" }}
            />
          </div>
        ))}
      </div>
      {contextHolder}

      <Modal
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
        footer={null}
        width={800}
        centered
        destroyOnClose
        title={data?.roomtypename || "Hình ảnh phòng"}
      >
        <Carousel infinite={photos.length > 1} dots={false} arrows>
          {photos.map((p, i) => (
            <div key={i}>
              <img
                src={p?.large || p?.origin || p?.medium || p?.small}
                alt=""
                className="w-full h-[480px] object-contain bg-black"
              />
            </div>
          ))}
        </Carousel>
      </Modal>

      {/* <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
          <img
            src={data.thumbnail.origin}
            alt=""
            className="absolute top-0 left-0 w-full h-full object-cover"
          />
        </div>
        <div className="p-4 bg-white rounded-bl-[12px] rounded-br-[12px] flex flex-col">
          <h3 className="text-[18px] mt-3 font-bold text-primary">
            {data.name}
          </h3>
          <ul className="mt-4">
            <li className="flex items-center mb-2">
              <img
                src="/images/dientich.png"
                alt=""
                className="w-[20px] mt-1"
              />
              <span className="text-[13px]">
                Diện tích: {data?.area?.squareMeter} m{" "}
                <sup className="text-[10px]">2</sup>
              </span>
            </li>
            <li className="flex items-center">
              <img src="/images/people.png" alt="" className="w-[20px] mt-1" />
              <span className="text-[13px]">
                Sức chứa: {data?.occupancy?.standardGuests} người
              </span>
            </li>
          </ul>
          <Button
            color="default"
            onClick={() => {
              setRoomlSelected(data);
            }}
            type="primary"
            className=" bg-primary text-white h-9 mt-3 w-[120px] ml-auto"
          >
            <span className="font-semibold">Đặt ngay</span>
          </Button>
        </div> */}
    </>
  );
};

export default RoomItem;
